module.exports = __webpack_public_path__ + "static/media/NotasFiscais5.c1c7e171.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancNotasFiscais/NotasFiscais5.png
// module id = 2135
// module chunks = 0